import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Layout } from "antd";

import HeaderComponent from "./components/Header";
import React, { useEffect, useState } from 'react';
import Map from "./views/Map";

import './App.css';
import Login from "./views/Login";
import store from "./store";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from 'react-redux'
import Options from "./views/Options";

let persistor = persistStore(store);

function App() {
    const [token, setToken] = useState("");
    const [ignored, setIgnored] = useState(0);

    // const state = useS

    useEffect(() => {
        window.addEventListener('storage', () => setIgnored(Math.floor(Math.random() * 10000000)), false);
    }, [])

    useEffect(() => {
        const token = localStorage.getItem('token');

        setToken(token || "")
    }, [ignored])

    return (
        <Router>
            <Provider store={store}>
                    {
                        token && (
                            <Layout style={{ overflow: 'hidden' }}>
                                <HeaderComponent/>

                                <Layout.Content>
                                    <Routes>
                                        <Route  path={'/options'} element={<Options />}/>
                                        <Route  path={'/'} element={<Map />}/>
                                    </Routes>
                                </Layout.Content>
                            </Layout>
                        )
                    }

                    { !token && <Login /> }
            </Provider>
        </Router>
    );
}

export default App;
